// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"Slider_swiperContainer__3tVHT","swiperWrapper":"Slider_swiperWrapper__1uTIQ","swiperPagination":"Slider_swiperPagination__1Sv-O"};